/**
 * Bricolage Grotesque (display / headings, 600–700) + Manrope (body / UI / numerals, 400–800).
 * Both are linked from public/index.html with display=swap; the fallback stacks keep layout sane.
 */
export const fonts = {
  heading: `"Bricolage Grotesque", "Manrope", system-ui, -apple-system, "Segoe UI", sans-serif`,
  body: `"Manrope", system-ui, -apple-system, "Segoe UI", sans-serif`,
  mono: `ui-monospace, SFMono-Regular, Menlo, monospace`,
};
